import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { CREATE_MANUAL_BOOKING, CREATE_MANUAL_BOOKING_SUCCESS, CREATE_MANUAL_BOOKING_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* createManualBooking({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/manual-booking`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
      params: payload?.urlParam,
    });

    if (response.status === 200) {
      // cogoToast.success(response?.data?.message);
      cogoToast.success(`Booking created successfully!`);
      yield put({
        type: CREATE_MANUAL_BOOKING_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CREATE_MANUAL_BOOKING_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_MANUAL_BOOKING_ERROR, payload: error });
  }
}

export function* watchCreateManuaBooking() {
  yield takeEvery(CREATE_MANUAL_BOOKING, createManualBooking);
}

function* createManualBookingSaga() {
  yield all([fork(watchCreateManuaBooking)]);
}

export default createManualBookingSaga;
